import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const ShareIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#FDFBF9"
      d="M6.69 20.77c-.43 0-.794-.15-1.09-.446a1.483 1.483 0 0 1-.446-1.09V9.581c0-.43.149-.793.445-1.09a1.486 1.486 0 0 1 1.094-.445H8.85v.923H6.693a.588.588 0 0 0-.423.193.588.588 0 0 0-.193.423v9.646c0 .154.064.295.193.423.128.128.269.192.423.192h10.615a.588.588 0 0 0 .423-.192.588.588 0 0 0 .192-.423V9.585a.588.588 0 0 0-.192-.423.588.588 0 0 0-.423-.193H15.16v-.923h2.15c.431 0 .796.149 1.093.445.296.297.445.66.445 1.09v9.653c0 .43-.149.794-.445 1.09-.297.297-.66.445-1.091.445H6.69Zm4.854-6.39V3.709L9.428 5.824l-.658-.655L12 1.94l3.231 3.23-.649.655-2.115-2.115v10.67h-.923Z"
    />
  </Svg>
)
export default ShareIcon
